import { Table } from '../../Table';
import useTable from '../../../hooks/useTable';
import { TableComponentProps } from '../types';

const columnLables = {
  liquidity_0_to_1_day: {
    name: 'Percentage of investor liquidity in 0 to 1 day',
    order: 186
  },
  liquidity_2_to_7_days: {
    name: 'Percentage of investor liquidity in 2 to 7 days',
    order: 187
  },
  liquidity_8_to_30_days: {
    name: 'Percentage of investor liquidity in 8 to 30 days',
    order: 188
  },
  liquidity_31_to_90_days: {
    name: 'Percentage of investor liquidity in 31 to 90 days',
    order: 189
  },
  liquidity_91_to_180_days: {
    name: 'Percentage of investor liquidity in 91 to 180 days',
    order: 190
  },
  liquidity_181_to_365_days: {
    name: 'Percentage of investor liquidity in 181 to 365 days',
    order: 191
  },
  liquidity_over_365_days: {
    name: 'Percentage of investor liquidity in more than 365 days',
    order: 192
  }
};

export function LiquidityRedemption({
  onChangeFund,
  funds,
  currentDataKey,
  schema,
  isStaticTemplate,
  isMultiFunds
}: TableComponentProps) {
  const {
    rows: rows,
    columns: columns,
    onChange: onChange
  } = useTable({
    data: funds[currentDataKey]?.fund_data?.INVESTOR_LIQUIDITY_PROFILE,
    onChangeFund,
    schema: schema.INVESTOR_LIQUIDITY_PROFILE,
    isStaticTemplate,
    requiredFields:
      funds[currentDataKey]?.required_tables?.INVESTOR_LIQUIDITY_PROFILE?.field_names || [],
    isMultiFunds,
    tableName: 'INVESTOR_LIQUIDITY_PROFILE',
    funds,
    columnLables
  });

  return (
    <Table
      id="reporttables-liquidity-redemption-table"
      handleChanges={onChange}
      columns={columns}
      rows={rows}
      stickyLeftColumns={isMultiFunds && Object.keys(funds).length > 2 ? 2 : null}
      stickyTopRows={isMultiFunds ? 1 : null}
    />
  );
}
